import script from "./AddAppointmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAppointmentModal.vue?vue&type=script&setup=true&lang=js"

import "./AddAppointmentModal.vue?vue&type=style&index=0&id=b775803a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b775803a"]])

export default __exports__